import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Target } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/risk/ras')({
    staticData: {
        breadcrumb: {
            title: 'Risk appetite statement',
        },
        ui: {
            icon: Target,
        },
    },
    component: Outlet,
});
